import "@/user/common";
import "@/shared/page/weddingdata/_index";

document.addEventListener("DOMContentLoaded", () => {
  /**
   * 表示項目の切替
   */
  const handleHashChange = () => {
    const type = window.location.hash.replace("#", ""); // アンカーリンクからタイプを取得
    const items = document.querySelectorAll(".facility-place");

    if (type.length > 0) {
      let matchedItems = 0;

      items.forEach((item) => {
        const displayStyle = item.style;
        if (item.classList.contains(type)) {
          displayStyle.display = "block";
          matchedItems++;
        } else {
          displayStyle.display = "none";
        }
      });

      // 該当タイプがない場合全表示
      if (matchedItems === 0) {
        window.location.hash = "#all";
        items.forEach((item) => {
          const displayStyle = item.style;
          displayStyle.display = "block";
        });
      }
    }
  };

  window.addEventListener("load", handleHashChange);
  window.addEventListener("hashchange", handleHashChange);
});
